import type {RuleValidationErrors} from '../types';
import type {AIRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

export const validateAIRule = <T extends AIRule = AIRule>(
	rule: T,
): RuleValidationErrors | false => {
	if (rule.elementValue1 === '') {
		return {
			elementValue1: createValidationObject(),
		};
	}
	return false;
};

export default validateAIRule;
